import { useState } from 'react';
import { useDailyIntention } from '@/hooks/useDailyIntention';
import { useLanguage } from '@/i18n/LanguageContext';
import { Feather, X } from 'lucide-react';

const DailyIntention = () => {
  const { intention, isToday, saveIntention, clearIntention } = useDailyIntention();
  const { t } = useLanguage();
  const [input, setInput] = useState('');

  if (isToday && intention) {
    return (
      <div className="relative p-4 rounded-xl border border-primary/10 bg-primary/5">
        <button
          onClick={clearIntention}
          className="absolute top-2 right-2 p-1 text-muted-foreground/30 hover:text-foreground transition-colors"
          aria-label="Clear"
        >
          <X className="w-3 h-3" />
        </button>
        <div className="flex items-start gap-3">
          <Feather className="w-4 h-4 text-primary/60 mt-0.5 shrink-0" />
          <div>
            <p className="text-[10px] uppercase tracking-widest text-muted-foreground/40 mb-1">
              {t('todays_intention') || "Today's Intention"}
            </p>
            <p className="text-sm font-light text-foreground/80 italic">"{intention}"</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 rounded-xl border border-border/20 bg-card/30">
      <div className="flex items-center gap-2 mb-3">
        <Feather className="w-4 h-4 text-muted-foreground/40" />
        <p className="text-[10px] uppercase tracking-widest text-muted-foreground/30">
          {t('set_intention') || 'Set an intention for today'}
        </p>
      </div>
      <div className="flex gap-2">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={t('intention_placeholder') || 'I will...'}
          maxLength={100}
          className="flex-1 bg-transparent border border-border/20 rounded-lg px-3 py-2 text-sm placeholder:text-muted-foreground/20 focus:outline-none focus:border-foreground/20"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && input.trim()) {
              saveIntention(input.trim());
              setInput('');
            }
          }}
        />
        <button
          onClick={() => {
            if (input.trim()) {
              saveIntention(input.trim());
              setInput('');
            }
          }}
          disabled={!input.trim()}
          className="px-3 py-2 text-xs border border-border/20 rounded-lg hover:border-foreground/20 transition-all disabled:opacity-30"
        >
          {t('set') || 'Set'}
        </button>
      </div>
    </div>
  );
};

export default DailyIntention;
